
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/wamo",
      function () {
        return require("private-next-pages/landing/wamo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/wamo"])
      });
    }
  